import React from 'react';
import { useTranslation } from 'react-i18next';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import HomePage from './pages/HomePage';
import ScanPage from './pages/ScanPage';
import AnalysisResultPage from './pages/AnalysisResultPage';
import HistoryPage from './pages/HistoryPage';
import CommunityPage from './pages/CommunityPage';
import CommunityProfilePage from './pages/CommunityProfilePage';
import AboutPage from './pages/AboutPage';

function App() {
  const { t } = useTranslation();

  return (
    <Router>
      <div className="min-h-screen flex flex-col bg-dark-bg">
        <a href="#main-content" className="skip-link">
          {t('common.skipToContent')}
        </a>
        <Navbar />
        <main id="main-content" className="flex-1 pt-16">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/scan/:id" element={<ScanPage />} />
            <Route path="/result/:identifier" element={<AnalysisResultPage />} />
            {/* Legacy redirect: /analysis/:id -> /result/:id */}
            <Route path="/analysis/:identifier" element={<AnalysisResultPage />} />
            <Route path="/history" element={<HistoryPage />} />
            <Route path="/community" element={<CommunityPage />} />
            <Route path="/community/:pseudo" element={<CommunityProfilePage />} />
            <Route path="/about" element={<AboutPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
